<template>
    <v-dialog v-model="thinking" persistent width="25%">
        <v-card class="d-flex flex-column align-center pa-5 menuItem">
            <v-img src="@/assets/critical-thinking.gif" width="150" contain></v-img>
            <v-card-title class="text-h4">
                {{ $t('line1') }}
            </v-card-title>
            <h5>{{ $t('line2') }}</h5>
        </v-card>
    </v-dialog>
</template>
<script>
import { mapGetters } from 'vuex';

export default {
    name: "thinkingViewer",
    data() {
        return {
            thinking: false,
        }
    },
    computed: {
        ...mapGetters(['getIsThinking'])
    },
    watch: {
        getIsThinking() {
            this.thinking = this.getIsThinking
        }
    }
}
</script>
<style>
</style>
<i18n>
{
  "en": {
      "line1": "Just a moment...",
      "line2": "I'm working on your request."
    },
  "es":{
      "line1": "Sólo un momento...",
      "line2": "Estoy trabajando en tu solicitud."
    }
}
</i18n>